import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 14, viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 13L1 7L7 1", stroke: "#EE3E5C", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgArrowLeft;
